export default __webpack_public_path__ + "static/media/Manage Your Stay.9679ae79.svg";